/**
 * @generated SignedSource<<9d1a72ae9c79083f70cd50b59159b49a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportLockStatusQuery$variables = {
  reportId: string;
};
export type ReportLockStatusQuery$data = {
  readonly viewer: {
    readonly reportLockStatus: {
      readonly locked: boolean | null;
      readonly heldByViewer: boolean | null;
      readonly holder: {
        readonly id: string;
        readonly fullName: string | null;
        readonly profilePictureId: string | null;
      } | null;
      readonly lockedAt: string | null;
      readonly expiresAt: string | null;
    } | null;
  } | null;
};
export type ReportLockStatusQuery = {
  variables: ReportLockStatusQuery$variables;
  response: ReportLockStatusQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reportId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "reportId",
      "variableName": "reportId"
    }
  ],
  "concreteType": "ReportLockStatus",
  "kind": "LinkedField",
  "name": "reportLockStatus",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "heldByViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "holder",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePictureId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresAt",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportLockStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportLockStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "da56b10dc75815050f6c2d4e28dcc539",
    "id": null,
    "metadata": {},
    "name": "ReportLockStatusQuery",
    "operationKind": "query",
    "text": "query ReportLockStatusQuery(\n  $reportId: ID!\n) {\n  viewer {\n    reportLockStatus(reportId: $reportId) {\n      locked\n      heldByViewer\n      holder {\n        id\n        fullName\n        profilePictureId\n      }\n      lockedAt\n      expiresAt\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "74e481f01b63b53ad7f51542d7a8d938";

export default node;
